module.exports = __webpack_public_path__ + "img/clear-style-icon.ed0aa914.svg";